import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgEditAccount = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 12,
	height: 12,
	viewBox: "0 0 12 12",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M2.22146 11.2391L0.065071 11.6703L0.496352 9.51393C0.573788 9.12675 0.764095 8.77115 1.04329 8.49195L8.27176 1.2634L9.21477 0.320388C9.60529 -0.0701362 10.2385 -0.0701369 10.629 0.320387L11.4149 1.10633C11.8054 1.49685 11.8054 2.13002 11.4149 2.52054L10.4719 3.46355L3.24345 10.6921C2.96425 10.9713 2.60865 11.1616 2.22146 11.2391Z",
		fill: "black"
	})
});
export default SvgEditAccount;
